export const INTRO_MESSAGE_ANCHOR_ID = 'automated-intro-message';
export const QUICK_REPLY_TEMPLATES_ANCHOR_ID = 'quick-reply-templates';
export const NEXT_STEP_TEMPLATES_ANCHOR_ID = 'next-steps-templates';

export const TEMPLATE_TAB_ANCHOR_IDS = [
  INTRO_MESSAGE_ANCHOR_ID,
  QUICK_REPLY_TEMPLATES_ANCHOR_ID,
  NEXT_STEP_TEMPLATES_ANCHOR_ID
];

export const leadsAutomationHref = (anchorId: string) =>
  `/provider/leads-automation#${anchorId}`;
